/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestDto } from '../../models/contents-request-dto';

export interface ContentsRequestControllerFindAll$Params {
}

export function contentsRequestControllerFindAll(http: HttpClient, rootUrl: string, params?: ContentsRequestControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentsRequestDto>>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContentsRequestDto>>;
    })
  );
}

contentsRequestControllerFindAll.PATH = '/api/contents-request';
